import { h, render } from 'preact';

import { preactMultipleWidgets } from '../../utils';
import { onLmpTabChange } from '../../../utils/aem-utils';

import { VideoPlaylistInlineComponent } from './component';
import widget from './widget-config';

const renderWidgets = () => {
  const widgets = preactMultipleWidgets(widget);
  widgets.forEach(({ $root, props }) => {
    render(<VideoPlaylistInlineComponent htmlProps={props.htmlProps} widget={widget} $root={$root} />, $root);
  });
};

export const hydrate = () => {
  renderWidgets();

  onLmpTabChange(() => {
    setTimeout(renderWidgets, 500);
  });
};
